import * as React from "react";
import { Line, StyledHamburgerButton } from "./HamburgerButton.components";

interface Props {
  active: boolean;
  onClick: () => void | Promise<void>;
}

const HamburgerButton: React.FunctionComponent<Props> = ({
  onClick,
  active,
}) => (
  <StyledHamburgerButton
    active={active}
    onClick={onClick}
    aria-label="Menu icon">
    <Line className="line-1" />
    <Line className="line-2" />
    <Line className="line-3" />
  </StyledHamburgerButton>
);

export default HamburgerButton;
